import styled from 'styled-components';
import { media } from '@sizeid/commons/utils/styles';

export default styled.div`
  .addresses {
    font-size: 1.3em;
    margin-bottom: 40px;
    > a {
      margin-right: 16px;
    }
    ${media.lessThan('sm')`
      > a {
        display: block;
      }
    `};
  }

  .people {
    display: flex;
    justify-content: center;
    margin-bottom: 40px;
    > div {
      margin: 0 40px;
    }
    img {
      height: 185px;
    }

    ${media.lessThan('sm')`
      > div {
        margin: 0 8px;
      }
      img {
        height: 80px;
      }      
    `};
  }
`;
